import React, { useState, useEffect } from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import YourLogo from '../../Assets/Images/Pro_Logo.png';
import '../../Assets/Style/style.css';
import './sidebar.css';
import { RxHamburgerMenu } from 'react-icons/rx';
import { AiOutlineStock, AiOutlineBulb } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../Redux/selecters';
import { RiReservedLine, RiRefund2Line, RiStickyNoteLine, RiIndeterminateCircleFill } from 'react-icons/ri';
import { TbLockAccess } from 'react-icons/tb';
import { FcApproval } from 'react-icons/fc';
import { TbStatusChange } from 'react-icons/tb';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { FaRegFile } from 'react-icons/fa6';
import {
  MdOutlineAssignment,
  MdSupportAgent,
  MdOutlineAnalytics,
  MdOutlineManageAccounts,
  MdAutorenew,
  MdOutlineAttachMoney,
  MdOutlineSwapHoriz,
  MdOutlineAccountBalanceWallet,
  MdOutlineEventBusy,
} from 'react-icons/md';
import { BsGraphDownArrow, BsBuilding } from 'react-icons/bs';
import { IoReceiptOutline, IoHomeOutline } from 'react-icons/io5';
import { FaUserTie } from 'react-icons/fa';

const PMSideBar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    lease: false,
    reports: false,
    master: false,
  });
  const [lastOpenMenu, setLastOpenMenu] = useState(null);
  const companies = useSelector(getCompany);
  const pathname = location.pathname;
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);

  useEffect(() => {
    setOpenMenus({
      master: location.pathname.startsWith('/Customer/Property/Master'),
    });
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.startsWith('/Customer/Property/Master')) {
      setLastOpenMenu('master');
    }
  }, [location.pathname]);
  useEffect(() => {
    if (location.pathname === '/' && lastOpenMenu) {
      setOpenMenus((prev) => ({
        ...prev,
        [lastOpenMenu]: true,
      }));
    }
  }, [location.pathname, lastOpenMenu]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          // <a href="/Inventory" className="navbar-brand start">
          //   <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '40px', paddingTop: '8px', paddingBottom: '8px' }} />
          // </a>
          ''
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '58px' }} />
            {/* <span className="logoName" style={{ marginLeft: '8px' }}>
              {companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.charAt(0).toUpperCase() +
                companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.slice(1).toLowerCase()}
            </span> */}
          </a>
        )}
        <Menu className="mt-2">
          {permissions?.some((permission) => permission.formName === 'Dashboard' && permission.canView) && (
            <MenuItem icon={<AiOutlineStock size={23} />} active={location.pathname === '/'}>
              <NavLink to="/">
                <div>DashBoard</div>
              </NavLink>
            </MenuItem>
          )}

          <SubMenu
            icon={<IoReceiptOutline size={22} />}
            title="Master"
            open={openMenus.master}
            onOpenChange={(open) => setOpenMenus((prev) => ({ ...prev, master: open }))}
          >
            {/* Customer */}
            {permissions?.some((p) => p.formName === "Customer" && p.canView) && (
              <MenuItem icon={<MdOutlineManageAccounts size={23} />} active={pathname.startsWith('/Customer/Property/Master/Customer/')}>
                <NavLink to="/Customer/Property/Master/Customer/Listing">
                  <div className={`submenu ${location.pathname === '/Customer/Property/Master/Customer/' ? 'subactive' : ''}`}>Customer Master</div>
                </NavLink>
              </MenuItem>
            )}
            {/* Agent */}
            {/* <MenuItem
              icon={<FaUserTie size={20} />}
              active={pathname.startsWith('/Customer/Property/Master/Agent/')}
            >
              <NavLink to="/Customer/Property/Master/Agent/listing">
                <div className={`submenu ${location.pathname === "/Customer/Property/Master/Agent" ? 'subactive' : ''}`}>
                  Agent Master
                </div>
              </NavLink>
            </MenuItem> */}
            {permissions?.some((p) => p.formName === "Property" && p.canView) && (
              <MenuItem icon={<BsBuilding size={20} />} active={pathname.startsWith('/Customer/Property/Master/Property/')}>
                <NavLink to="/Customer/Property/Master/Property/listing">
                  <div className={`submenu ${location.pathname === '/Customer/Property/Master/Property' ? 'subactive' : ''}`}>Property Master</div>
                </NavLink>
              </MenuItem>
            )}
            {permissions?.some((p) => p.formName === "Unit" && p.canView) && (
              <MenuItem
                icon={<HiOutlineOfficeBuilding size={22} />}
                active={pathname.startsWith('/Customer/Property/Master/Unit/') && !pathname.includes('/Release')}
              >
                <NavLink to="/Customer/Property/Master/Unit/Listing">
                  <div className={`submenu ${location.pathname === '/Customer/Property/Master/Unit' ? 'subactive' : ''}`}>Unit Master</div>
                </NavLink>
              </MenuItem>
            )}
            {/* {permissions?.some((p) => p.formName === "Unit Release" && p.canView) && (
              <MenuItem icon={<MdAutorenew size={22} />} active={pathname.startsWith('/Customer/Property/Master/Unit/Release')}>
                <NavLink to="/Customer/Property/Master/Unit/Release/Listing">
                  <div className={`submenu ${pathname.startsWith('/Customer/Property/Master/Unit/Release') ? 'subactive' : ''}`}>Unit Release</div>
                </NavLink>
              </MenuItem>
            )} */}
             {
             permissions?.some((p) => p.formName === "Agent Master" && p.canView) && (
              <MenuItem icon={<MdAutorenew size={22} />} active={pathname.startsWith('/Customer/Property/Master/Agent/')}>
                <NavLink to="/Customer/Property/Master/Agent/Listing">
                  <div className={`submenu ${pathname.startsWith('/Customer/Property/Master/Agent/') ? 'subactive' : ''}`}>Agent Master</div>
                </NavLink>
              </MenuItem>
              )
            }
            
          {  
          permissions?.some((p) => p.formName === "Unit Block" && p.canView)&& (
            <MenuItem icon={<TbLockAccess size={22} />} active={pathname.startsWith('/Customer/Property/Master/UnitBlock/')}>
              <NavLink to="/Customer/Property/Master/UnitBlock/Listing">
              <div className={`submenu ${pathname.startsWith('/Customer/Property/Master/UnitBlock/') ? 'subactive' : ''}`}>Unit Block</div>
              </NavLink>
            </MenuItem>
          )}
 
          {/* {permissions?.some((p) => p.formName === "Unit Release" && p.canView)&& (
            <MenuItem icon={<RiReservedLine size={22} />} active={pathname.startsWith('/Customer/Property/Master/UnitRelease/')}>
              <NavLink to="/Customer/Property/Master/UnitRelease/Listing">
                <div className={`submenu ${pathname.startsWith('/Customer/Property/Master/UnitRelease/') ? 'subactive' : ''}`}>Unit Release</div>
              </NavLink>
            </MenuItem>
          )} */}

          {permissions?.some((p) => p.formName === "Unit Release" && p.canView)&& (
            <MenuItem icon={<MdOutlineEventBusy size={22} />} active={pathname.startsWith('/Customer/Property/Master/UnitReleaseRA/')}>
              <NavLink to="/Customer/Property/Master/UnitReleaseRA/Listing">
                <div className={`submenu ${pathname.startsWith('/Customer/Property/Master/UnitReleaseRA/') ? 'subactive' : ''}`}>Unit Release</div>
              </NavLink>
            </MenuItem>
          )}

          </SubMenu>
        </Menu>
        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '100px' : '300px' }}>
          <RxHamburgerMenu size={25} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default PMSideBar;
